import axios from "@/libs/http";
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 游戏设置列表
 */
export const listGameSetting = () => {
    return axios.request({
        url: '/s/c/clerkGameSetting/list',
        method: 'get'
    })
}

/**
 * 更新段位
 */
export const updateGameSetting = (gameCategoryId, type, rankId) => {
    let data = new URLSearchParams()
    data.append('gameCategoryId', gameCategoryId)
    data.append('rankType',type)
    appendIfNotEmpty(data,'rankId',rankId)
    return axios.request({
        url: '/s/c/clerkGameSetting/update',
        data,
        method: 'post'
    })
}

/**
 * 获取订单列表
 */
export const getOrderList = (pageNo, pageSize , types, status) => {
  let data = new URLSearchParams()
  data.append("pageNo", pageNo)
  data.append("pageSize", pageSize)
  data.append("types", types)
  data.append("status", status)
  return axios.request({
    url: '/s/c/dispatchOrder/list',
    data,
    method: 'post'
  })
}

/**
 * 获取订单详情
 */
export const getOrder = (id) => {
  return axios.request({
    url: '/s/c/dispatchOrder/get',
    params: {
      id
    },
    method: 'get'
  })
}

/**
 * 确认订单
 */
export const confirmOrder = (id,version) => {
  return axios.request({
    url: '/s/c/dispatchOrder/confirm',
    params: {
      id, version
    },
    method: 'post'
  })
}

/**
 * 开始服务
 */
export const startService = (id) => {
  return axios.request({
    url: '/s/c/dispatchOrder/startService',
    params: {
      id
    },
    method: 'post'
  })
}

/**
 * 结束服务
 */
export const endService = (id)=>{
  return axios.request({
    url: '/s/c/dispatchOrder/endService',
    params: {
      id
    },
    method: 'post'
  })
}



/**
 * 上传订单选项
 */
export const getUploadOrderOptions = ()=>{
    return axios.request({
        url: '/s/c/dispatchOrder/getUploadOrderOptions',
        method: 'get'
    })
}

/**
 * 价格设置
 */
export const getPriceSetting = (priceType,gameCategoryId)=>{
    return axios.request({
        url: '/s/c/dispatchOrder/getPriceSetting',
        params: {
            priceType,gameCategoryId
        },
        method: 'get'
    })
}

/**
 * 上传订单
 */
export const uploadOrder = (priceType,gameCategoryId,clerkGradeId,gameRankId,kfId,note,hourPrice,hourWage)=>{
    let data = new URLSearchParams()
    data.append('priceType',priceType)
    data.append('gameCategoryId',gameCategoryId)
    data.append('kfId',kfId)
    appendIfNotEmpty(data,'clerkGradeId',clerkGradeId)
    appendIfNotEmpty(data,'gameRankId',gameRankId)
    appendIfNotEmpty(data,'note',note)
    data.append('hourPrice',hourPrice)
    data.append('hourWage',hourWage)
    return axios.request({
        url: '/s/c/dispatchOrder/uploadOrder',
        data,
        method: 'post'
    })
}

/**
 * 上传外派订单
 */
export const uploadOutDispatchOrder = (orderListStr)=>{
    let data = new URLSearchParams()
    data.append('orderListStr',orderListStr)
    return axios.request({
        url: '/s/c/dispatchOrder/uploadOutDispatchOrder',
        data,
        method: 'post'
    })
}

/**
 *  获取店员列表(更换店员)
 *  */
export const getClerkList = (clerkName) => {
    return axios.request({
        url: '/s/c/dispatchOrder/getClerkList',
        params: {
            clerkName
        },
        method: 'get'
    })
}

/**
 * 更换店员
 * */
export const replaceOrderClerk = (id, clerkId) => {
    var data = new URLSearchParams();
    data.append("id", id);
    data.append("clerkId", clerkId);
    return axios.request({
        url: '/s/c/dispatchOrder/replaceOrderClerk',
        data,
        method: 'post'
    })
}
